import { Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";

export default function Portal() {
  return (
    <main data-testid="portal-page" className="min-h-[60vh] flex items-center justify-center bg-[#FAF9F6] px-6">
      <div className="text-center max-w-md py-24">
        <Lock size={28} className="text-[#B0895C] mx-auto" />
        <div className="eyebrow mt-6">Host&apos;s Portal</div>
        <h1 className="font-serif-display text-4xl text-[#2A1F1A] mt-3">Coming soon.</h1>
        <p className="mt-4 text-sm text-[#6E6E70] leading-relaxed">
          A private space for Janté hosts — bookings, reports, payouts and your Sasha, all in one place.
          We&apos;re building it now.
        </p>
        <Link to="/" data-testid="portal-back-home" className="btn-secondary inline-flex items-center gap-2 px-5 py-2.5 text-sm mt-8">
          <ArrowLeft size={14} /> Back home
        </Link>
      </div>
    </main>
  );
}
